import React from "react";
import ApplicationLogo from "@/Components/Global/ApplicationLogo";
import { Link } from "@inertiajs/react";
import NavButton from "@/Components/Global/NavButton";

const GuestHeader = () => {
    return (
        <>
            <div className="sticky top-0 z-50 bg-white dark:bg-secondary-dark">
                <div className="max-w-[1440px] m-auto">
                    <div className="flex justify-between items-center h-[60px] xl:h-[90px] px-[4vw]  md:px-6 2xl:px-0">
                        <div className=" h-full xl:h-auto xl:justify-center flex">
                            <Link className="pt-2 xl:pt-0  xl:w-full" href="/">
                                <ApplicationLogo className="h-full w-[100px] xl:h-auto block fill-current text-gray-800 dark:text-text-dark" />
                            </Link>
                        </div>

                        <nav className="flex gap-[20px] xl:gap-[40px]">
                            <NavButton scrollTo="aboutUsSection">
                                about us
                            </NavButton>
                            <NavButton scrollTo="reviewsSection">
                                participate
                            </NavButton>
                            <NavButton scrollTo="contactSection">
                                contact
                            </NavButton>
                        </nav>

                        <div className="flex items-center gap-8">
                            <div className="text-black dark:text-text-dark">
                                <Link
                                    href="/login"
                                    className="mr-2 text-sm xl:text-[20px] font-semibold"
                                >
                                    login
                                </Link>
                            </div>
                            <div className="h-[52px] xl:h-[70px] mt-2 xl:mt-5">
                                <img
                                    src="/assets/images/icons/profileLight.svg"
                                    alt="User Avatar"
                                    className="h-full"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default GuestHeader;
